import React from 'react';

import {
  useLoadCategory,
  useUpdateCategory,
  useCreateCategory,
  useIsUpdating,
} from 'scenes/Influencers/InfluencersChannels/data';

import CategoryForm from './CategoryForm';
import { PARENT_CATEGORY } from './constants';

export const CategoryFormCreate = ({
  parentCategory,
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const [createCategory] = useCreateCategory();
  const isUpdating = useIsUpdating();

  const handleSubmit = async (values = {}) => {
    const category = await createCategory(values);

    onSubmit(category);
  };

  return (
    <CategoryForm
      title={'Add Category'}
      loading={isUpdating}
      onClose={onClose}
      initialValues={{
        [PARENT_CATEGORY]: parentCategory,
      }}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
      isSubCategory={!!parentCategory}
    />
  );
};

export const CategoryFormEdit = ({ id, onSubmit, onClose, onExited, open }) => {
  const { data, isLoading } = useLoadCategory(id);
  const [updateCategory] = useUpdateCategory();
  const isUpdating = useIsUpdating();

  const handleSubmit = async (values = {}) => {
    await updateCategory(values);
    onSubmit(values);
  };

  return (
    <CategoryForm
      title={'Edit Category'}
      loading={isLoading || isUpdating}
      onClose={onClose}
      initialValues={data}
      active={!!data}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
      id={id}
    />
  );
};
